import React from "react";
import PropTypes from "prop-types";

const EmailValidationError = () => (
  <p data-quid="email-validation-error" className="validation-error email">
    Please enter a valid email address
  </p>
);

const PasswordValidationError = () => (
  <p
    data-quid="password-validation-error"
    className="validation-error password"
  >
    Please enter a password
  </p>
);

const LoginFailedError = () => (
  <p data-quid="login-failed-error" className="validation-error login-fail">
    We could not locate a Pizza Profile with that e-mail and password
    combination. Please make sure you are using the e-mail address associated
    with your Domino&apos;s Pizza Profile.
  </p>
);

const TooManyAttemptsError = ({ showOverlay }) => (
  <p
    data-quid="too-many-attempts-error"
    className="validation-error login-fail"
  >
    This account has been locked for exceeding the number of invalid login
    attempts. If the email address you provided is valid, we'll send a password
    reset link to the provided email address. If you do not receive the password
    reset email, please check your spam folder.
    <button
      data-quid="reset-password"
      type="button"
      className="reset-password underline"
      onClick={() => showOverlay("forgotPassword")}
    >
      reset password
    </button>
  </p>
);

const LoginRecaptchaNotification = () => (
  <p
    data-quid="login-recaptcha-notification"
    className="validation-error login-fail"
  >
    Please help us protect your account by checking "I'm not a robot"
  </p>
);

const LoginRecaptchaError = () => (
  <p data-quid="login-recaptcha-error" className="validation-error login-fail">
    Sorry, something went wrong. Please try again.
  </p>
);

TooManyAttemptsError.propTypes = {
  showOverlay: PropTypes.func.isRequired
};

export {
  EmailValidationError,
  PasswordValidationError,
  LoginFailedError,
  TooManyAttemptsError,
  LoginRecaptchaNotification,
  LoginRecaptchaError
};
